/**
 * Auth layout
 */

// React
import React from 'react';

// Components
import Footer from 'components/Footer';
import Loading from 'components/Loading';
import AppLogo from 'components/AppLogo';
import SnackNotify from 'components/SnackNotify';
import Header from 'components/Header';

// Common styles
import { ContainerCustom, ContentLayout, LayoutContainer, LogoContainer } from 'styles';

// Utils
import { AuthLayoutProps } from 'utils/types';

const AuthLayout: React.FC<AuthLayoutProps> = ({
  children,
  showHeader = true,
  showFooter = true,
  maxWidth,
  alignItems = 'start',
  showLogo = true,
  background = '#FFFFFF',
}) => {
  return (
    <LayoutContainer
      sx={{
        background: background,
      }}
    >
      {showHeader && <Header />}
      <SnackNotify />
      <Loading />
      <ContentLayout
        sx={{
          alignItems: alignItems,
        }}
      >
        <ContainerCustom
          maxWidth={maxWidth ? maxWidth : false}
          sx={{
            paddingX: maxWidth ? { xs: '30px', sm: '30px', md: '0px' } : '0px !important',
          }}
        >
          {showLogo && (
            <LogoContainer>
              <AppLogo />
            </LogoContainer>
          )}
          {children}
        </ContainerCustom>
      </ContentLayout>
      {showFooter && <Footer />}
    </LayoutContainer>
  );
};

export default AuthLayout;
